import { render, staticRenderFns } from "./OpSelectArray.vue?vue&type=template&id=6b4c96fb&"
import script from "./OpSelectArray.vue?vue&type=script&lang=js&"
export * from "./OpSelectArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports